<!-- Modern Excel Import Dashboard -->
<div class="min-h-screen bg-gradient-to-br from-indigo-50 to-purple-50 p-6">
  
  <!-- Header Section -->
  <div class="mb-8">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <!-- Title and Description -->
      <div>
          <h1 class="text-3xl font-bold text-gray-900 mb-2">
          <svg class="w-8 h-8 inline-block mr-3 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
          </svg>
          {{ "DATA_IMPORT_CENTER" | translate }}
        </h1>
        <p class="text-gray-600">
          {{'IMPORT_DESC' | translate}}
        </p>
      </div>
      
      <!-- Progress Indicator -->
      <div class="bg-white rounded-lg px-6 py-4 shadow-sm border border-gray-200">
        <div class="flex items-center gap-4">
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 rounded-full" 
                 [ngClass]="importForm.get('improle')?.value ? 'bg-green-500' : 'bg-gray-300'"></div>
            <span class="text-sm font-medium text-gray-700">{{'STEP_1_CONFIGURE' | translate}}</span>
          </div>
          <div class="w-8 h-px bg-gray-300"></div>
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 rounded-full" 
                 [ngClass]="rowData.length > 0 ? 'bg-green-500' : 'bg-gray-300'"></div>
            <span class="text-sm font-medium text-gray-700">{{'STEP_2_UPLOAD' | translate}}</span>
          </div>
          <div class="w-8 h-px bg-gray-300"></div>
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 rounded-full bg-gray-300"></div>
            <span class="text-sm font-medium text-gray-700">{{'STEP_3_REVIEW' | translate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Import Form -->
  <form [formGroup]="importForm" class="space-y-8">
    
    <!-- Configuration Section -->
    <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
      <!-- Section Header -->
      <div class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-indigo-50 to-purple-50">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
            </svg>
          </div>
          <div>
            <h2 class="text-lg font-semibold text-gray-900">{{'IMPORT_CONFIGURATION' | translate}}</h2>
            <p class="text-sm text-gray-600">{{'IMPORT_PREFERENCES_DESC' | translate}}</p>
          </div>
        </div>
      </div>

      <!-- Configuration Form -->
      <div class="p-6">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          
          <!-- Organization Name -->
          <div class="space-y-2">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-2">
              <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
              </svg>
              {{ "ORG_NAME" | translate }}
            </label>
            <div class="relative">
              <input
                type="text"
                [value]="orgname"
                readonly
                class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 text-gray-700 focus:outline-none cursor-not-allowed"
              />
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                </svg>
              </div>
            </div>
          </div>

          <!-- Branch Selection -->
       
          <div class="space-y-2" *ngIf="type != 'Branch' && branchList.length > 0">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-2">
              <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
              </svg>
              {{ "employee.branch" | translate }}
              <span class="text-red-500 text-xs">*</span>
            </label>
            <select
              formControlName="branchId"
              class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-white focus:bg-white focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 focus:outline-none transition-all duration-200"
              [class.border-red-300]="importForm.get('branchId')?.invalid && importForm.get('branchId')?.touched"
            >
              <option value="">{{ "employee.select_branch" | translate }}</option>
              <option
                *ngFor="let branch of branchList"
                [value]="branch.branch_id"
              >
                {{ branch.branch_name }}
              </option>
            </select>
            <p class="text-xs text-red-500" *ngIf="importForm.get('branchId')?.invalid && importForm.get('branchId')?.touched">
             {{'BRANCH_REQUIRED' | translate}}
            </p>
          </div>

          <!-- Import Type Selection -->
          <div class="space-y-2">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-2">
              <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
              {{'IMPORT_TYPE' | translate}}
              <span class="text-red-500 text-xs">*</span>
            </label>
            <div class="flex gap-2">
              <input
                type="text"
                formControlName="improle"
                readonly
                class="flex-1 px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 text-gray-700 focus:outline-none cursor-not-allowed"
              />
              <button
                type="button"
                *ngIf="importForm.get('improle')?.value && ['Project', 'Projects', 'Staff', 'Employee', 'Material', 'Materials', 'Machine', 'Machines'].includes(importForm.get('improle')?.value)"
                (click)="downloadTemplate()"
                class="inline-flex items-center px-4 py-3 border border-indigo-300 text-sm font-medium rounded-xl text-indigo-700 bg-indigo-50 hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200"
                title="Download template file"
              >
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
                Template
              </button>
            </div>
            <p class="text-xs text-red-500" *ngIf="importForm.get('improle')?.invalid && importForm.get('improle')?.touched">
                            {{'IMPORT_TYPE_REQUIRED' | translate}}

            </p>
          </div>
        </div>

        <!-- Import Type Info Cards -->
        <div class="mt-6 grid grid-cols-2 lg:grid-cols-6 gap-3 hidden" *ngIf="!importForm.get('improle')?.value">
          <div class="bg-gray-50 rounded-lg p-3 text-center hover:bg-gray-100 transition-colors duration-200 cursor-pointer"
               *ngFor="let type of impTypes"
               (click)="importForm.patchValue({improle: type})">
            <div class="w-8 h-8 mx-auto mb-2 bg-gray-200 rounded-lg flex items-center justify-center">
              <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </div>
            <span class="text-xs font-medium text-gray-700">{{ type }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- File Upload Section -->
    <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden" 
         *ngIf="importForm.get('improle')?.value">
      
      <!-- Section Header -->
      <div class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
              </svg>
            </div>
            <div>
              <h2 class="text-lg font-semibold text-gray-900">Upload Excel or CSV File</h2>
              <p class="text-sm text-gray-600">Select your Excel or CSV file to import {{ importForm.get('improle')?.value }} data</p>
            </div>
          </div>
          <button
            type="button"
            *ngIf="importForm.get('improle')?.value && ['Project', 'Projects', 'Staff', 'Employee', 'Material', 'Materials', 'Machine', 'Machines'].includes(importForm.get('improle')?.value)"
            (click)="downloadTemplate()"
            class="inline-flex items-center px-4 py-2 border border-indigo-300 text-sm font-medium rounded-lg text-indigo-700 bg-white hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200"
            title="Download template file"
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
            Download Template
          </button>
        </div>
      </div>

      <!-- File Upload Area -->
      <div class="p-6">
        <div class="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center hover:border-indigo-400 transition-colors duration-300"
             [class.border-indigo-400]="rowData.length > 0"
             [class.bg-indigo-50]="rowData.length > 0">
          
          <!-- Upload Icon and Content -->
          <div class="space-y-4">
            <div class="mx-auto w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center">
              <svg class="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
              </svg>
            </div>
            
            <div>
              <h3 class="text-lg font-medium text-gray-900 mb-2">
                {{ rowData.length > 0 ? 'File Uploaded Successfully!' : 'Drop your Excel or CSV file here' }}
              </h3>
              <p class="text-gray-600 mb-4">
                {{ rowData.length > 0 ? rowData.length + ' rows detected' : 'or click to browse for files' }}
              </p>
              
              <!-- File Input -->
              <div class="relative inline-block">
                <input
                  type="file"
                  (change)="onFileChange($event)"
                  accept=".xlsx,.xls,.csv"
                  class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  id="file-upload"
                />
                <label
                  for="file-upload"
                  class="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-xl text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200 cursor-pointer transform hover:scale-105 active:scale-95"
                >
                  <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
                  </svg>
                  {{ rowData.length > 0 ? 'Replace File' : 'Choose File' }}
                </label>
              </div>
            </div>

            <!-- File Info -->
            <div class="text-xs text-gray-500">
              {{'SUPPORTED_FORMATS' | translate}}
            </div>
          </div>
        </div>

        <!-- Upload Success Message -->
        <div class="mt-4 p-4 bg-green-50 border border-green-200 rounded-xl" *ngIf="rowData.length > 0">
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0">
              <svg class="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <div class="flex-1">
              <h4 class="text-sm font-medium text-green-800">{{'FILE_PROCESSED_SUCCESS' | translate}}</h4>
              <div class="mt-2 text-sm text-green-700">
                <ul class="list-disc list-inside space-y-1">
                  <li>{{ rowData.length }} {{'ROWS_DETECTED' | translate}}</li>
                  <li>{{ columnDefs.length }} {{'COLUMNS_IDENTIFIED' | translate}}</li>
                  <li>{{'DATA_TYPE' | translate}}: {{ importForm.get('improle')?.value }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Data Preview Section -->
    <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden" 
         *ngIf="rowData.length > 0">
      
      <!-- Section Header -->
      <div class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-green-50 to-blue-50">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </div>
            <div>
              <h2 class="text-lg font-semibold text-gray-900">{{'DATA_PREVIEW_VALIDATION' | translate}}</h2>
              <p class="text-sm text-gray-600">{{'REVIEW_BEFORE_IMPORT' | translate}}</p>
            </div>
          </div>
          
          <!-- Action Buttons -->
          <div class="flex items-center gap-3">
            <button
              type="button"
              class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200"
              (click)="rowData = []; columnDefs = []"
            >
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
              </svg>
              {{'RESET' | translate}}
            </button>
            
            <button
              type="button"
              (click)="saveChanges()"
              [disabled]="rowData.length === 0 || (type != 'Branch' && !importForm.get('branchId')?.value)"
              class="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-xl text-white bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-200 transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none shadow-lg"
            >
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"></path>
              </svg>
              {{'IMPORT_DATA' | translate}} ({{ rowData.length }} rows)
            </button>
          </div>
        </div>
      </div>

      <!-- Data Grid -->
      <div class="p-6">
        <div class="bg-gray-50 rounded-xl p-4 mb-4">
          <div class="flex items-center gap-4 text-sm text-gray-600">
            <div class="flex items-center gap-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <span>{{'EDIT_CELLS_HINT' | translate}}</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-3 h-3 bg-blue-500 rounded-full"></div>
              <span>{{ rowData.length }} {{'TOTAL_ROWS' | translate}}</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-3 h-3 bg-green-500 rounded-full"></div>
              <span>{{ columnDefs.length }} {{'COLUMNS' | translate}}</span>
            </div>
          </div>
        </div>

        <!-- AG Grid Container -->
        <div class="rounded-xl overflow-hidden border border-gray-200 shadow-sm">
          <ag-grid-angular
            class="ag-theme-alpine"
            style="width: 100%; height: 500px;"
            [rowData]="rowData"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [pagination]="true"
            [paginationPageSize]="20"
            [rowSelection]="'multiple'"
            [animateRows]="true"
          ></ag-grid-angular>
        </div>
      </div>
    </div>

    <!-- Import Result Details: failures + duplicates from the last import attempt.
         Surfaces the *actual* per-row error (e.g. "No active subscription with
         user limit found") so users don't have to read the network panel. -->
    <div
      class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden"
      *ngIf="importResult && (importResult.failedRecords.length > 0 || importResult.duplicateRecords.length > 0)"
    >
      <div class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-red-50 to-orange-50">
        <div class="flex items-center justify-between gap-3 flex-wrap">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 9v2m0 4h.01M4.93 19h14.14c1.54 0 2.5-1.67 1.73-3L13.73 4a2 2 0 00-3.46 0L3.2 16c-.77 1.33.19 3 1.73 3z"/>
              </svg>
            </div>
            <div>
              <h2 class="text-lg font-semibold text-gray-900">Import Results</h2>
              <p class="text-sm text-gray-600">{{ importResult.message || 'Some rows could not be imported.' }}</p>
            </div>
          </div>
          <div class="flex items-center gap-4 text-sm" *ngIf="importResult.summary as s">
            <span class="text-gray-600">Total: <strong class="text-gray-900">{{ s.totalRows }}</strong></span>
            <span class="text-green-700">Imported: <strong>{{ s.successful }}</strong></span>
            <span class="text-red-700">Failed: <strong>{{ s.failed }}</strong></span>
            <span class="text-amber-700">Duplicates: <strong>{{ s.duplicates }}</strong></span>
            <button
              type="button"
              (click)="clearImportResult()"
              class="ml-2 inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50"
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>

      <div class="p-6 space-y-6">
        <!-- Failed rows -->
        <div *ngIf="importResult.failedRecords.length > 0">
          <h3 class="text-sm font-semibold text-red-700 mb-3">
            {{ importResult.failedRecords.length }} row<ng-container *ngIf="importResult.failedRecords.length !== 1">s</ng-container> failed
          </h3>
          <div class="overflow-x-auto rounded-xl border border-red-200">
            <table class="min-w-full text-sm">
              <thead class="bg-red-50 text-red-800">
                <tr>
                  <th class="px-4 py-2 text-left font-semibold w-16">Row</th>
                  <th class="px-4 py-2 text-left font-semibold w-1/3">Identifier</th>
                  <th class="px-4 py-2 text-left font-semibold">Reason</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-red-100 bg-white">
                <tr *ngFor="let f of importResult.failedRecords">
                  <td class="px-4 py-2 font-medium text-gray-900">{{ f.row }}</td>
                  <td class="px-4 py-2 text-gray-700 break-all">{{ failedRowLabel(f) || '—' }}</td>
                  <td class="px-4 py-2 text-red-700">{{ f.error }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Duplicate rows -->
        <div *ngIf="importResult.duplicateRecords.length > 0">
          <h3 class="text-sm font-semibold text-amber-700 mb-3">
            {{ importResult.duplicateRecords.length }} duplicate row<ng-container *ngIf="importResult.duplicateRecords.length !== 1">s</ng-container> skipped
          </h3>
          <div class="overflow-x-auto rounded-xl border border-amber-200">
            <table class="min-w-full text-sm">
              <thead class="bg-amber-50 text-amber-800">
                <tr>
                  <th class="px-4 py-2 text-left font-semibold w-16">Row</th>
                  <th class="px-4 py-2 text-left font-semibold w-1/3">Identifier</th>
                  <th class="px-4 py-2 text-left font-semibold">Reason</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-amber-100 bg-white">
                <tr *ngFor="let d of importResult.duplicateRecords">
                  <td class="px-4 py-2 font-medium text-gray-900">{{ d.row }}</td>
                  <td class="px-4 py-2 text-gray-700 break-all">{{ failedRowLabel(d) || '—' }}</td>
                  <td class="px-4 py-2 text-amber-700">{{ d.reason || 'Already exists' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="bg-white rounded-2xl shadow-lg border border-gray-200 p-12 text-center"
         *ngIf="!importForm.get('improle')?.value">
      <div class="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
        <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
        </svg>
      </div>
      <h3 class="text-xl font-medium text-gray-900 mb-3">{{'READY_TO_IMPORT' | translate}}</h3>
        <p class="text-gray-500 mb-6 max-w-md mx-auto">
       {{'SELECT_IMPORT_TYPE_HINT' | translate}}
      </p>
      <div class="text-sm text-gray-400">
       {{'IMPORT_STEPS_FLOW' | translate}}
        
      </div>
    </div>

  </form>
</div>